import { useState } from "react";
import { useAdminInvites } from "@/api/admin/invites";
import { usePagination } from "@/api/pagination";
import { useDebounce } from "@/hooks/use-debounce";
import { SendInviteModal } from "@/pages/admin/modals/send-invite";
import { PageHeader } from "@/pages/admin/page-header";
import { AdminInvitesTable } from "@/pages/admin/tables/invites";

export const InvitesPage = () => {
  const [search, setSearch] = useState("");
  const debouncedSearch = useDebounce(search);
  const pagination = usePagination();
  const { data } = useAdminInvites(pagination.pagination, { column: "createdAt", direction: "desc" }, { text: "" });

  return (
    <div className="h-full flex flex-col gap-6 mt-4 px-12">
      <PageHeader
        title="Invites"
        subtitle="Pending and sent invitations"
        count={data?.total}
        search={search}
        onSearchChange={setSearch}
        actions={<SendInviteModal />}
      />
      <div className="flex-1 min-h-0 flex flex-col overflow-auto">
        <AdminInvitesTable search={debouncedSearch} />
      </div>
    </div>
  );
};
